var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgErrorIco = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 148,
    viewBox: "0 0 123 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.4286L25.0971 15.9943C30.8698 15.2044 36.4567 13.3926 41.5975 10.6435L61.5 0L82.24 10.8502C87.2362 13.464 92.6431 15.1976 98.2248 15.9756L123 19.4286V65.099C123 88.8166 111.662 111.097 92.5103 125.016L60.885 148L29.922 125.043C11.1026 111.089 0 89.0115 0 65.5425V19.4286Z",
    fill: "#37809F",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.651 145.602L60.885 148L92.5103 125.016C111.662 111.097 123 88.8166 123 65.099V19.4286L119.31 18.9143V63.0637C119.31 86.7984 107.956 109.093 88.7812 123.009L57.651 145.602Z",
    fill: "#37809F",
    fillOpacity: 0.24
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3247 48.1C46.3247 40.437 53.1189 34.225 61.5 34.225C69.8811 34.225 76.6753 40.437 76.6753 48.1V61.975H46.3247V48.1ZM81.7338 61.975V48.1C81.7338 37.8827 72.6748 29.6 61.5 29.6C50.3252 29.6 41.2662 37.8827 41.2662 48.1V61.975H35.3647C30.2429 61.975 26.0909 65.7713 26.0909 70.4542V95.1208C26.0909 99.8037 30.2429 103.6 35.3647 103.6H87.6353C92.7571 103.6 96.9091 99.8037 96.9091 95.1208V70.4542C96.9091 65.7713 92.7571 61.975 87.6353 61.975H81.7338ZM61.5 75.85C58.7063 75.85 56.4416 77.9207 56.4416 80.475V85.1C56.4416 87.6543 58.7063 89.725 61.5 89.725C64.2937 89.725 66.5584 87.6543 66.5584 85.1V80.475C66.5584 77.9207 64.2937 75.85 61.5 75.85Z",
    fill: "#37809F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0303 64.1333C31.9133 64.1333 28.5758 67.4464 28.5758 71.5333V80.1667C28.5758 80.5683 28.608 80.9624 28.67 81.3466C29.57 72.3085 36.8111 65.1203 45.916 64.2269C45.5289 64.1653 45.1318 64.1333 44.7273 64.1333H36.0303Z",
    fill: "#5F99B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.916 101.08C91.033 101.08 94.3706 97.7669 94.3706 93.68V85.0467C94.3706 84.6451 94.3383 84.2509 94.2763 83.8667C93.3763 92.9049 86.1352 100.093 77.0304 100.986C77.4174 101.048 77.8145 101.08 78.219 101.08H86.916Z",
    fill: "#5F99B2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgErrorIco);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/error-ico.08761eafd26d884420f5473d64fc9460.svg";